export enum MessageType {
    Ai,
    Human
}

export default class Message {
    constructor(public memberId: string, public content: string, public type: MessageType) {}
}